import React, { useEffect, useMemo, useRef, useState } from "react";

export const LineClampComponent = ({
    content,
    lines = 10,
    showMoreText = "Show more",
    showLessText = "Show less",
    className = ""
  }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [needsTruncation, setNeedsTruncation] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);
  
    useEffect(() => {
      const checkTruncation = () => {
        if (contentRef.current) {
          const element = contentRef.current;
          const lineHeight = parseInt(getComputedStyle(element).lineHeight);
          const maxHeight = lineHeight * lines;
          setNeedsTruncation(element.scrollHeight > maxHeight);
        }
      };
  
      checkTruncation();
      window.addEventListener('resize', checkTruncation);
  
      return () => {
        window.removeEventListener('resize', checkTruncation);
      };
    }, [content, lines]);
  
    const toggleExpanded = () => {
      setIsExpanded(!isExpanded);
    };
  
    const contentStyle = useMemo(() => ({
      ...(isExpanded ? {} : {
        WebkitLineClamp: lines,
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical' as const
      })
    }), [isExpanded, lines]);
  
    return (
      <div className={`${className}`}>
        <div
          ref={contentRef}
          className='overflow-hidden transition-all duration-300'
          style={contentStyle}
        >
          {content}
        </div>
        {needsTruncation && (
          <a
            className="font-hurmegeometric-sans text-[13px] leading[20px] text-brown-prime cursor-pointer underline"
            onClick={toggleExpanded}
          >
            {isExpanded ? showLessText : showMoreText}
          </a>
        )}
      </div>
    );
  };